import { render, staticRenderFns } from "./RegisterFormComp.vue?vue&type=template&id=05b22a5c&scoped=true&"
import script from "./RegisterFormComp.vue?vue&type=script&lang=ts&"
export * from "./RegisterFormComp.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterFormComp.vue?vue&type=style&index=0&id=05b22a5c&lang=scss&scoped=true&"
import style1 from "./RegisterFormComp.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b22a5c",
  null
  
)

export default component.exports